// extracted by mini-css-extract-plugin
module.exports = {"group":"form_group_group__382qd","title":"form_group_title__3pCTR","content":"form_group_content__12iZF"};